import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_credenciales} from '@/FirebaseConfig'
import {toSlug, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
    state: {
      data:{
        plateNumber:'',
        createdAt:'',
      },
      record:{}
    },
    mutations: {
      getAllItems(state, item) {
        Vue.set( state.record, item.id, {...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} )
      },
      eliminar(state,key){
        Vue.delete(state.record,key)
      }
    },
    actions: {
      obtener_todo:(context)=>{
        context.state.record = {}
        coleccion_credenciales.onSnapshot(data=>data.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
      },
      agregar: context => {
        coleccion_credenciales.add({
          nombre: '', 
          valores: [
            {
              descripcion: '',
              valor: '',
            }
          ],
          creado_el: new Date()
        }).then(()=>{
          context.commit('Helpers/launchSnackbar', 'Se ha creado una credencial', { root: true })
        })
      },
      eliminar: (context, key) => {
        coleccion_credenciales.doc(key).delete().then(()=>{
          context.commit( 'eliminar', key)
          context.commit('Helpers/launchSnackbar', 'Se ha eliminado la credencial', { root: true })
        })
      },
      actualizar: (context, data) => {
        coleccion_credenciales.doc(data.key).update({
          nombre: data.credencial.nombre,
          valores: data.credencial.valores,
          slug: toSlug(data.credencial.nombre),
          actualizado_el: new Date() 
        }).then(()=>  context.commit('Helpers/launchSnackbar', 'Se ha actualizado', { root: true }) )
      },
    },
    getters: {
      registro: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
    },
  }
  